// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface RESTMailboxProtectionOptions
 */
export interface RESTMailboxProtectionOptions {
    /**
     * Specifies the ID of an organization for which the mailbox protection report will be generated.
     * @type {string}
     * @memberof RESTMailboxProtectionOptions
     */
    organizationId?: string | null;
    /**
     * Specifies the format in which to save a report.
     * @type {string}
     * @memberof RESTMailboxProtectionOptions
     */
    format?: RESTMailboxProtectionOptionsFormatEnum;
    /**
     * Specifies a time zone for the reporting interval. If you do not specify this property, the server will generate a report for the UTC time zone.
     * @type {string}
     * @memberof RESTMailboxProtectionOptions
     */
    timezone?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTMailboxProtectionOptionsFormatEnum {
    Pdf = 'PDF',
    Csv = 'CSV'
}

